import { Component } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';

enum Selectors {
	hiddenInput = '.js-m-hidden-url__hidden-input',
}

@Component('HiddenUrl')
export class HiddenUrl extends GondelJqueryComponent {
	public sync() {
		this.setValue();
	}

	private setValue() {
		const urlType = this.$ctx.data('url-type') || 'location';
		const $hiddenInput = this.$ctx.find(Selectors.hiddenInput);
		if (urlType === 'location') {
			$hiddenInput.val(document.location.href);
		} else {
			$hiddenInput.val(document.referrer);
		}
	}
}
